import MsgThreadListItem from './MessageThreadListItem';

export default MsgThreadListItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadListItem/index.js